export default __webpack_public_path__ + "static/media/NotebookWomanBlackBg.d3468ec5.png";